import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, VerticalAlign, WidthType } from "docx"

export const page2Heading = new Paragraph({
    spacing: { before: 50, after: 600 },

    children: [
        new TextRun({
            text: "Document Review and Approval History",
            color: "C00000",
            font: "Cambria(Headings)",
            size: 22,
            bold: true,
            italics: false,
            characterSpacing: "0.5pt"
        })
    ]
})


export function page2firstTable(dateString) {
    const [dayStr, monthStr, yearStr] = dateString.split('/');
    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10) - 1; // JS months are 0-based
    const year = parseInt(yearStr, 10);

    const date = new Date(year, month, day);
    if (isNaN(date.getTime())) {
        throw new Error(`Invalid dateString: ${dateString}`);
    }

    function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const ordinalSuffix = getOrdinalSuffix(day);
    const formattedDay = `${day}${ordinalSuffix} ${monthNames[month]} ${year}`;
    return new Table({

        width: { size: 100, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 450 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        },

        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        width: { size: 14.5, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Version Number",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 25, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Date",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 23, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,

                                children: [
                                    new TextRun({
                                        text: "Reviewer and Approver",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 38, type: WidthType.PERCENTAGE },
                        verticalAlign: VerticalAlign.CENTER,
                        children: [
                            new Paragraph({
                                spacing: { before: 200, after: 200 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Remark",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1.0",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: formattedDay,
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    }),
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Manjunath N G",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 190, after: 190 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Final Review",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                ]
            }),
        ]
    })
}


export const page2Heading2 = new Paragraph({
    spacing: { before: 700, after: 600 },

    children: [
        new TextRun({
            text: "Team Members",
            color: "C00000",
            font: "Cambria(Headings)",
            size: 22,
            bold: true,
            italics: false,
            characterSpacing: "0.5pt"
        })
    ]
})

export const page2secondTable = new Table({
    width: { size: 68, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 450 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
    },

    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 25, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Sl. No",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "003366" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 75, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            spacing: { before: 200, after: 200 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Consultant Name",
                                    font: "Calibri",
                                    size: 22,
                                    color: "ffffff",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "003366" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 120, after: 120 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 120, after: 120 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Kapil Bardewa",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                }),
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 120, after: 120 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "2",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 120, after: 120 },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Aghilesh B",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                }),
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),
    ]
})
